module.exports = __webpack_public_path__ + "img/icon-goal-5.90f6ed6c.svg";